import './index.less';
import RevxFlexLayout from 'components/RevxFlexLayout';
import RevxLogoText from 'components/RevxLogoText';
import RevxJobListFilter, {
  FilterOptionsParams,
} from 'components/RevxJobListFilter';
import React, { useEffect, useState } from 'react';
import {
  JobItem,
  JobStatusFilterSeparateTabEnum,
  JobWorkflowStatusEnum,
  JobWorkspaceFilterTypeEnum,
} from 'domains/workspaceDomain';
import { useAppDispatch } from 'app/hooks';
import JobArchiveItem from './components/JobArchiveItem';
import { RevxJobInfiniteList } from 'components/RevxJobInfiniteList';
const { STANDARD_JOBS } = JobStatusFilterSeparateTabEnum;
const { JOB_ARCHIVE } = JobWorkspaceFilterTypeEnum;

const JobArchive = () => {
  const [totalElements, setTotalElements] = useState(0);
  const [currentPageCount, setCurrentPageCount] = useState(0);
  const [preConfigTabActiveKey] =
    useState<JobStatusFilterSeparateTabEnum>(STANDARD_JOBS);
  const [filterOptions, setFilterOptions] = useState<FilterOptionsParams>();
  const filter = JobWorkflowStatusEnum.COMPLETED;
  const { workspace } = useAppDispatch();

  useEffect(() => {
    workspace.reloadJobList?.();
    setCurrentPageCount(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOptions]);

  const itemRender = ({ items }: { items?: JobItem[] | undefined }) => {
    return (
      <>
        {(items || []).map((item: JobItem) => (
          <div className="main-content__job-list__item">
            <JobArchiveItem item={item} refreshJobList={() => {}} />
          </div>
        ))}
      </>
    );
  };

  const getJobList = async (page: number) => {
    const listData = await workspace.getPageJobList({
      page,
      size: 40,
      filter,
      ...filterOptions,
      filterType: JOB_ARCHIVE,
    });
    setCurrentPageCount((v) => v + listData.content.length);
    setTotalElements(listData.totalElements);
    return listData;
  };

  return (
    <div className="job-archive-layout">
      <RevxFlexLayout>
        <RevxLogoText
          text="Job Archive"
          colors={[
            'blue',
            'red',
            'yellow',
            'black',
            'blue',
            'red',
            'yellow',
            'black',
            'blue',
            'red',
            'yellow',
          ]}
        />
      </RevxFlexLayout>
      <RevxJobListFilter
        total={totalElements}
        displayTotal={currentPageCount}
        statusFilterSeparateTab={preConfigTabActiveKey}
        filterType={JOB_ARCHIVE}
        callback={(v) => {
          setFilterOptions({ ...filterOptions, ...v });
        }}
      />
      <div className="pre-c-list-wrapper">
        <div className="pre-c-list">
          <div className="pre-c-list__item">
            <RevxFlexLayout align="top" className="w-100">
              <div className="main-content">
                <div className="main-content__job-list">
                  <RevxJobInfiniteList
                    loadMore={getJobList}
                    render={itemRender}
                    jobStatus={filter}
                    initialLoad={false}
                  />
                </div>
              </div>
            </RevxFlexLayout>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobArchive;
